export enum Ranking {
    Leader,
    Expert,
    Beginner,
    Advanced,
    Experienced
}
